import { X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function PwaUpdateNotice() {
  const registration = useRef<ServiceWorkerRegistration | undefined>(undefined);
  const [applying, setApplying] = useState(false);
  const [error, setError] = useState(false);
  const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW({
    onRegisteredSW: (_, value) => { registration.current = value; },
  });

  useEffect(() => {
    const check = () => {
      if (document.visibilityState === 'visible' && navigator.onLine)
        void registration.current?.update().catch(() => {});
    };
    const timer = window.setInterval(check, 60 * 60 * 1000);
    document.addEventListener('visibilitychange', check);
    window.addEventListener('online', check);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', check);
      window.removeEventListener('online', check);
    };
  }, []);

  if (!needRefresh) return null;
  const apply = async () => {
    setApplying(true);
    setError(false);
    try { await updateServiceWorker(); }
    catch { setError(true); setApplying(false); }
  };
  return <aside className="inline-notice pwa-update-notice" role="status" aria-live="polite">
    <span>{error ? 'Не удалось обновить. Повторите попытку.' : 'Доступна новая версия приложения.'}</span>
    <button className="button button--secondary" type="button" disabled={applying} onClick={() => void apply()}>
      {applying ? 'Обновляем…' : 'Обновить'}
    </button>
    <button className="icon-button icon-button--small" type="button" disabled={applying}
      aria-label="Обновить позже" onClick={() => setNeedRefresh(false)}><X size={17} aria-hidden="true" /></button>
  </aside>;
}
